import React, { useEffect, useState } from "react";
import imgUrl from "../components/assets/images/GauravInGreen.jpeg";

const Gaurav = () => {

  return (
    <div>
      <img src={imgUrl} alt="Gaurav" />
    </div>
  );
};

export default Gaurav;
